import React, { useRef, useState } from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import ProductInfo from '../components/ProductInfo';
import CustomerReview from '../components/CustomerReview';
import BadgeHeroSection from '../components/HeroSectionBadge';
import NumberStatement from '../components/NumberStatement';
import NewsCarousel from '../components/NewsCarousel';
import WhySwitchToLit from '../components/WhySwitchToLit';
import CommunityReview from '../components/CommunityReview';
import AnyQuestions from '../components/AnyQuestions';
import GetSEOData from '../data/SEO';
const LocationTemplate = ({ data }) => {
  const locationData = data.datoCmsTownLandingPageContent;
  const townName = data.datoCmsTownLandingPageModel.townName;
  const townSpecificData = data.datoCmsTownLandingPageModel;
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedPackage, setSelectedPackage] = useState();
  const regionalPromo = data.datoCmsTownLandingPageModel.regionalPromotionCode;
  let { title, description } = GetSEOData('location');
  return (
    <div className="bootstrap">
      <div className="town-container">
        <SEO
          title={locationData.seo?.title ?? title}
          description={locationData.seo?.description ?? description}
          metaTags={locationData.seo}
        />
        <BadgeHeroSection
          heading={locationData.hero[0].heading}
          subHeading={locationData.hero[0].subheading}
          secondaryHeroImage={townSpecificData.hero[0].heroImageDesktop}
          arrowsLeft={locationData.hero[0].arrowsLeft}
          arrowsRight={locationData.hero[0].arrowsRight}
          mode={locationData.hero[0].mode}
          layout={locationData.hero[0].layout}
          townName={townName}
        />
        <NumberStatement
          numberStatementData={
            locationData.switchToLitContainer[0].modularContent
          }
          header={locationData.switchToLitContainer[0].heading}
          backgroundColor={locationData.switchToLitContainer[0].backgroundColor}
          id={'number-statement'}
        />{' '}
        <ProductInfo
          header={`Our latest offers for ${townName}`}
          subheader={
            "Whether you're an occasional browser, boxset binger or hardcore gamer, we have the speed you need"
          }
          forceRegionalPromo={regionalPromo}
          setSelectedPlan={setSelectedPlan}
          selectedPlan={selectedPlan}
          setSelectedPackage={setSelectedPackage}
          selectedPackage={selectedPackage}
        />
        <WhySwitchToLit
          heading={locationData.whyGetLitContainer[0].heading}
          switchData={locationData.whyGetLitContainer[0].modularContent}
          backgroundColor={locationData.whyGetLitContainer[0].backgroundColor}
        />
        <NewsCarousel
          heading={locationData.newsCarouselHeading}
          backgroundColor={'Yellow'}
          townName={townName}
        />{' '}
        <NumberStatement
          numberStatementData={locationData.factContainer[0].modularContent}
          header={locationData.factContainer[0].heading}
          backgroundColor={locationData.factContainer[0].backgroundColor}
          townName={townName}
        />
        <CommunityReview
          communityReviewHeader={
            townSpecificData.communityManagerContainer[0].heading
          }
          communityReview={townSpecificData.communityManagerContainer[0].quote}
          communityReviewerTitle={
            townSpecificData.communityManagerContainer[0].author
          }
          communityReviewImage={
            townSpecificData.communityManagerContainer[0].quoteImage
          }
          buttonPath={townSpecificData.communityManagerContainer[0].buttonPath}
          buttonText={townSpecificData.communityManagerContainer[0].buttonText}
        />
        <CustomerReview />
        <AnyQuestions />
      </div>
    </div>
  );
};

export default LocationTemplate;
export const pageQuery = graphql`
  query ($id: String!) {
    datoCmsTownLandingPageModel(id: { eq: $id }) {
      seo {
        description
        title
        twitterCard
        image {
          gatsbyImageData
        }
      }
      townName
      titleTag
      regionalPromotionCode
      hero {
        heroImageMobile {
          gatsbyImageData
        }
        heroImageDesktop {
          gatsbyImageData
        }
      }
      communityManagerContainer {
        ... on DatoCmsHeadingQuoteButtonImageBlock {
          id
          quote {
            value
          }
          author {
            value
          }
          buttonText
          buttonPath
          heading {
            value
          }
          quoteImage {
            gatsbyImageData
          }
        }
      }
    }
    datoCmsTownLandingPageContent {
      hero {
        heading {
          value
        }
        subheading {
          value
        }
        heroImageDesktop {
          gatsbyImageData
        }
        heroImageMobile {
          gatsbyImageData
        }
        arrowsRight {
          gatsbyImageData
        }
        arrowsLeft {
          gatsbyImageData
        }
        mode
        layout
      }
      switchToLitContainer {
        backgroundColor
        heading {
          value
        }
        modularContent {
          ... on DatoCmsHeadingBodyBlock {
            id
            heading {
              value
            }
            body {
              value
            }
          }
        }
      }
      newsCarouselHeading {
        value
      }
      factContainer {
        backgroundColor
        heading {
          value
        }
        modularContent {
          ... on DatoCmsHeadingBodyBlock {
            heading {
              value
            }
            body {
              value
            }
          }
        }
      }
      whyGetLitContainer {
        backgroundColor
        heading {
          value
        }
        modularContent {
          ... on DatoCmsHeadingImageBodyBlock {
            featureImage {
              gatsbyImageData
            }
            heading {
              value
            }
            body {
              value
            }
          }
        }
      }
      communityManagerContainer {
        heading {
          value
        }
        buttonText
        buttonPath
        quote {
          value
        }
        author {
          value
        }
        quoteImage {
          gatsbyImageData
        }
      }
    }
  }
`;
